var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "7.9375mm",
    height: "10.583mm",
    viewBox: "0 0 7.9375 10.583333",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(.18899 -139.76)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.26458 0 0 .26458 524.22 295.15)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m-1982-587.31h30v40h-30z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.1896)",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    },
    "aria-label": 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1963.7-583.64v32.676h-4.6713v-28.005h-5.6054v-4.6712z",
    strokeWidth: "1px",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.4c34eda7d317dca63e3257ceb52e711b.svg";
export { ForwardRef as ReactComponent };